import { styled } from "@mui/material";
import Tabs from "../../Tabs";

export const StyledPickersLayoutTabs = styled(Tabs)`
  width: 100%;
  border-color: ${(props) => props.theme.wsc.palette.neutral[600]};
  min-height: ${(props) => props.theme.wsc.size.xxl};

  .MuiTabs-flexContainer {
    gap: ${(props) => props.theme.wsc.spacing[2]};
  }

  .MuiTab-root {
    min-height: ${(props) => props.theme.wsc.size.xxl};
  }
`;
